import { useQuery } from '@tanstack/react-query';

import { listStaffGroups } from '@/api/staff-group-api';

const STAFF_GROUPS_KEY = ['staff-groups'] as const;

function staffGroupsKey(siteIds: string[] | undefined) {
  return siteIds && siteIds.length > 0
    ? ([...STAFF_GROUPS_KEY, { siteIds: [...siteIds].sort() }] as const)
    : (STAFF_GROUPS_KEY as readonly unknown[]);
}

/**
 * Lists staff groups, optionally scoped to one or more sites (A12 / D43).
 * Pass `siteIds` from the wizard's active template-sites selection so
 * the shift-modal picker only offers groups that can actually be
 * assigned at the target sites. Omit `siteIds` for the landing's group
 * filter, which lists every group on the realm.
 *
 * The cache key sorts the site list so `['s2','s1']` and `['s1','s2']`
 * resolve to the same query rather than two.
 */
export function useStaffGroups(siteIds?: string[]) {
  return useQuery({
    queryKey: staffGroupsKey(siteIds),
    queryFn: () => listStaffGroups(siteIds),
  });
}
